import { Box, BoxProps, Stack, Typography, styled } from '@mui/material';
import { forwardRef } from 'react';

type MapControlSectionProps = BoxProps & {
  title?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
};

export const MapControlSection = styled(
  forwardRef<HTMLDivElement, MapControlSectionProps>(
    ({ title, actions, children, ...props }, ref) => (
      <Box
        ref={ref}
        {...props}
        sx={{
          padding: 5,
          paddingBottom: 0,
          ...props.sx,
        }}
      >
        {(title || actions) && (
          <Stack
            direction='row'
            justifyContent='space-between'
            alignItems='center'
            sx={{ mb: 1 }}
          >
            {title && (
              <Typography
                variant='subtitle2'
                sx={{
                  margin: 0,
                  color: 'text.secondary',
                }}
              >
                {title}
              </Typography>
            )}
            {actions && (
              <Stack direction='row' alignItems='center' spacing={1}>
                {actions}
              </Stack>
            )}
          </Stack>
        )}
        {children}
      </Box>
    )
  )
)({});
